export default __webpack_public_path__ + "static/media/order-check.616db889.svg";